import React from 'react';

import Chip, { ChipProps } from '@components/Chip';
import { useChats } from '@context/ChatsContext';
import { useAddOrOpenChatWithUserIdsMutation } from '@db/Chats/Queries';
import { errorAlert } from '@helpers/Alert';
import { Plan } from '@types';

type MessageButtonProps = {
  onChat: (chatId: string) => void;
  plan: Plan;
} & Omit<ChipProps, 'children'>;

export default function MessageButton({ onChat, plan, ...props }: MessageButtonProps) {
  const { chats } = useChats();
  const addOrOpenChatMutation = useAddOrOpenChatWithUserIdsMutation({ chats });
  const loading = addOrOpenChatMutation.isPending;

  const onPress = () => {
    if (loading) return;

    addOrOpenChatMutation.mutate(
      { userIds: [...new Set([plan.userId, ...(plan.userIds ?? [])])] },
      {
        onError: (error) => errorAlert(error, { onAction: onPress }),
        onSuccess: (chatId) => onChat(chatId),
      }
    );
  };

  return (
    <Chip disabled={loading} icon="chat-outline" onPress={onPress} {...props}>
      Chat
    </Chip>
  );
}
